import React, { useContext } from "react";
import { Navigate } from "react-router-dom";

import { SessionContext } from "../../contexts/SessionContext";

const PermissionGuard = ({ permission, children }) => {
   const { state } = useContext(SessionContext);
   const permissions = state.permissions || [];

   if (!permissions.includes(permission)) {
      return <Navigate to="/site/dashboard" replace />;
   }

   return <React.Fragment>{children}</React.Fragment>;
};

export default PermissionGuard;
